import {ENDPOINT_URL, TEST_VERSION} from 'constants/index';
const headers = new Headers();
headers.append('Content-Type', 'application/json');

export default function createTest(type) {
	return fetch(`${ENDPOINT_URL}/newtestkey`, {
		method: 'POST',
		mode: 'cors',
		credentials: 'include',
		headers,
		body: JSON.stringify({type, testVersion: TEST_VERSION}),
	})
		.then((response) => {
			if (response.ok) {
				return response.json();
			}
			let errorMessage;
			if (response.status === 500) {
				errorMessage = 'Ikke gyldig testKode ';
				return Promise.reject(errorMessage);
			}

			return Promise.reject(response);
		})
		.catch((error) => {
			console.log('error', error);
		});
}
